<template>
    <div class="">
        <div class="">
            <h2 class="text-center mt-4">Verification</h2>
            <h4 class="text-center mt-3">Security Questions</h4>
            <div v-for="(quizElement, indexQuestion) in interactiveQuery" :key="indexQuestion" class="px-4 mt-4">
                <p class="fw-bold">{{quizElement.question}}</p>
                <div class="form-check mb-2" v-for="(option, key, indexOption) in quizElement.options" :key="key">
                    <label class="form-check-label" :for="'option' + '-' + indexQuestion + '-' + key">
                        <input class="form-check-input" type="radio" :name="'option' + '-' + indexQuestion" :id="'option' + '-' + indexQuestion + '-' + key"
                        @change="selectAnswer(parseInt(indexQuestion), parseInt(indexOption) + 1)"/>
                        {{option}}
                    </label>
                </div>
            </div>
            <!-- action bottons section -->
            <div class="d-grid gap-2 d-md-flex justify-content-md-center">
                <div class="d-grid gap-2 col-8 col-md-2 mx-auto">
                    <a v-if="showSkipVerification"
                        class="btn btn-lg btn-light"
                        id="btnSkip"
                        @click.prevent="executeSkipVerification">Skip</a>

                    <a class="btn btn-lg"
                        :class="[isQuizCompleted ? 'btn-primary' : 'btn-secondary disabled']"
                        :disabled="!isQuizCompleted"
                        id="btnNext"
                        @click.prevent="getVerified">Next</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLoadingState } from '@/composables/useLoadingState.js';
import { clearNotifications } from '@/utils/notifications.js';
import { scrollToTop } from '@/utils/scroll.js';
import { useInjectedApplicationSettings } from '@/composables/useApplicationSettingsProvider.js';

const props = defineProps({
    quiz: {
        type: Object,
        required: true,
    },
    showSkipVerification: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const emit = defineEmits(['getVerified']);

const applicationSettings = useInjectedApplicationSettings();

const questionsWithAnswers = ref({});
const errors = ref(null);
const { isLoading } = useLoadingState();

const isQuizCompleted = computed(() => {
    return questionsWithAnswers.value && (Object.values(questionsWithAnswers.value).length > 2);
});

const interactiveQuery = computed(() => {
    return !!props.quiz.interactiveQuery ? Object.values(props.quiz.interactiveQuery)[0] : null;
});

function selectAnswer(question, answer) {
    questionsWithAnswers.value[question] = answer;
}

function executeSkipVerification() {
    clearNotifications(applicationSettings);
    applicationSettings.userWantsVerification = false;
}

function getVerified() {
    scrollToTop();

    if (isQuizCompleted.value) {
        const answers = Object.fromEntries(Object.entries(questionsWithAnswers.value).map(([key, val]) => [key, val]));
        const payload = {
            transaction_key: props.quiz.transactionKey,
            answers,
        };
        emit('getVerified', payload);
    }
}
</script>
